module.exports = __webpack_public_path__ + "img/bldc_adc.80b00737.png";